import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const ptBR = {
  translation: {
    hero: {
      headline: "Advocacia Estratégica em Jundiaí e Região",
      subtext: "Soluções seguras em Direito do Trabalho para trabalhadores e empresas, além de assessoria jurídica para condomínios. Atendimento humanizado, transparente e focado em trazer equilíbrio e segurança jurídica para a sua vida, para o seu negócio ou para o seu condomínio. Atendimento presencial em Jundiaí e online para todo o Brasil.",
      ctaPrimary: "Falar no WhatsApp",
      ctaSecondary: "Conhecer as áreas de atuação",
      region: "Atendimento em Jundiaí e região · Online para todo o Brasil",
      trust: "Atendimento individual e sigiloso. Você conversa sempre com uma advogada."
    },
    about: {
      title: "Sobre a Luara",
      who: {
        title: "Quem sou",
        text: "Com mais de 15 anos de experiência no Direito, construí minha trajetória atuando em grandes escritórios e corporações. Ao longo dessa jornada, conheci profundamente os bastidores das relações de trabalho e das gestões institucionais.\n\nHojé, à frente do meu próprio escritório, utilizo essa bagagem de forma multifacetada: oferecendo defesa técnica e humana para trabalhadores, implementando prevenção de riscos para empresas e trazendo segurança jurídica para a gestão de condomínios."
      },
      mission: {
        title: "Missão",
        text: "Atuar com clareza, estratégia e comprometimento na resolução de conflitos e na segurança jurídica de trabalhadores, empresas e condomínios."
      },
      vision: {
        title: "Visão", 
        text: "Ser referência em Jundiaí e região pela excelência em advocacia trabalhista e condominial, traduzindo a complexidade jurídica em soluções práticas."
      },
      purpose: {
        title: "Propósito",
        text: "Acreditamos no Direito como instrumento de equilíbrio, segurança e pacificação das relações."
      }
    },
    practiceAreas: {
      title: "Como Podemos Ajudar",
      subtitle: "Atuação estratégica nas seguintes frentes:",
      worker: {
        title: "Direito do Trabalho para Trabalhadores",
        shortDescription: "Orientação e defesa dos seus direitos trabalhistas diante de conflitos, rescisões, horas extras, reconhecimento de vínculo, assédio, acidentes de trabalho e ambientes tóxicos.",
        intro: "Defendemos os seus direitos com respeito, transparência e a segurança de quem conhece profundamente os bastidores das relações de trabalho.",
        cta: "Entender meus direitos",
        ctaLong: "Quero avaliar meu caso",
        servicesList: [
          "Análise do caso concreto e orientação jurídica",
          "Cálculo e conferência de verbas rescisórias",
          "Análise de contratos, holerites e modelos de contratação PJ",
          "Orientação em casos de assédio, pressão psicológica e ambiente tóxico",
          "Acordos e negociações extrajudiciais",
          "Reconhecimento de vínculo empregatício",
          "Horas extras e banco de horas",
          "Adicionais de insalubridade e periculosidade",
          "Danos morais, assédio e discriminação",
          "Acidente de trabalho e doença ocupacional",
          "Rescisão indireta",
          "Equiparação salarial"
        ]
      },
      corporate: {
        title: "Direito do Trabalho para Empresas",
        shortDescription: "Consultoria trabalhista preventiva, auditoria de contratos, redução de passivo trabalhista, apoio ao RH e defesa em ações judiciais.",
        intro: "Defendemos o patrimônio e a sustentabilidade da sua empresa por meio de uma gestão jurídica trabalhista inteligente, preventiva e estratégica.",
        cta: "Proteger minha empresa",
        ctaLong: "Quero proteger minha empresa",
        servicesList: [
          "Consultoria preventiva para RH e departamento pessoal",
          "Revisão de contratos de trabalho",
          "Adequação de jornadas, benefícios e políticas internas",
          "Auditoria de passivo trabalhista",
          "Análise de contratação PJ e terceirização",
          "Defesa em reclamações trabalhistas",
          "Apoio em audiências, mediações e fiscalizações",
          "Estratégia para redução de riscos e previsibilidade jurídica"
        ]
      },
      condominium: {
        title: "Direito Condominial",
        shortDescription: "Assessoria jurídica para síndicos, administradoras e conselhos, com foco em inadimplência, assembleias, convenções, regimentos e conflitos condominiais.",
        intro: "A vida em condomínio exige regras claras, mediação ágil e segurança jurídica. Apoiamos síndicos, conselhos e administradoras na busca por uma gestão eficiente, harmoniosa e juridicamente segura.",
        cta: "Valorizar meu condomínio",
        ctaLong: "Quero apoio para meu condomínio",
        servicesList: [
          "Cobrança amigável e judicial de cotas condominiais",
          "Revisão de convenções e regimentos internos",
          "Assessoria em assembleias presenciais e virtuais",
          "Apoio na elaboração de editais e atas",
          "Mediação de conflitos entre moradores",
          "Orientação em obras, uso de áreas comuns e regras internas",
          "Relações trabalhistas do condomínio",
          "Análise de contratos com terceirizadas"
        ]
      }
    },
    methodology: {
      title: "Como funciona?",
      subtitle: "Minha abordagem é baseada em três pilares fundamentais que garantem um atendimento completo e personalizado.",
      steps: {
        listen: {
          title: "Escuta",
          text: "Primeiro, escuto sua história com atenção. Entendo o contexto, os fatos e suas preocupações para mapear a situação."
        },
        analyze: {
          title: "Análise",
          text: "Analiso seu caso sob a perspectiva jurídica, identificando direitos, prazos e as melhores estratégias de atuação."
        },
        strategy: {
          title: "Estratégia",
          text: "Desenvolvo um plano de ação personalizado, explicando as opções disponíveis e os caminhos mais adequados para seu caso."
        }
      }
    },
    differentiators: {
      title: "Diferenciais",
      items: {
        communication: {
          title: "Comunicação Clara",
          text: "Orientação sem juridiquês, com explicações objetivas para que você entenda riscos, caminhos e próximos passos."
        },
        experience: {
          title: "Experiência de Bastidor",
          text: "A vivência em grandes escritórios e corporações permite uma visão estratégica das relações de trabalho, da prevenção de riscos e da gestão institucional."
        },
        preventive: {
          title: "Abordagem Preventiva",
          text: "Atuação voltada a evitar conflitos, reduzir riscos e trazer mais segurança antes que o problema se transforme em processo."
        },
        human: {
          title: "Atendimento Humanizado",
          text: "Escuta ativa, transparência e condução cuidadosa em temas que impactam pessoas, empresas e comunidades."
        }
      }
    },
    testimonials: {
      title: "O que dizem sobre o atendimento",
      items: {
        testimonial1: {
          text: "A Luara me explicou tudo com calma e resolveu meu caso com muita transparência.",
          author: "[Nome]",
          role: "[Profissão]"
        },
        testimonial2: {
          text: "Me senti segura para decidir. Recomendo o atendimento humano da Luara.",
          author: "[Nome]",
          role: "[Empresa]"
        }
      },
      note: "Depoimentos publicados somente com consentimento expresso.",
      cases: {
        title: "Casos de Sucesso",
        disclaimer: "* Relatos reais anonimizados para proteção de identidade em conformidade com o código de ética.",
        condominium: {
          title: "Recuperação de Inadimplência",
          text: "Condomínio enfrentava 30% de inadimplência crônica. Em 6 meses de gestão jurídica ativa, com cobranças extrajudiciais humanizadas e plantões de negociação, reduzimos o déficit para menos de 5%, garantindo fluxo de caixa para manutenções urgentes."
        },
        worker: {
          title: "Reconhecimento de Vínculo",
          text: "Trabalhador atuava há mais de 4 anos como prestador de serviços (PJ) mas com rotina de celetista. Conseguimos o reconhecimento judicial do vínculo empregatício e o pagamento integral do FGTS, férias proporcionais e 13º salário."
        }
      }
    },
    faq: {
      title: "Dúvidas Frequentes",
      tabs: {
        worker: "Direito do Trabalho para Trabalhadores",
        corporate: "Direito do Trabalho para Empresas",
        condominium: "Direito Condominial"
      }
    },
    content: {
      title: "Conteúdos & Blog",
      subtitle: "Artigos e orientações estratégicas.",
      categories: {
        worker: {
          title: "Direitos do Trabalhador",
          description: "Artigos sobre verbas rescisórias, horas extras, ambiente de trabalho, vínculo empregatício, assédio e direitos no trabalho."
        },
        corporate: {
          title: "Gestão & Empresas",
          description: "Conteúdos sobre prevenção de riscos trabalhistas, contratos seguros, rotinas de RH, conformidade legal e proteção empresarial."
        },
        condominium: {
          title: "Vida em Condomínio",
          description: "Orientações para síndicos, conselheiros e moradores sobre inadimplência, assembleias, regras internas, conflitos e gestão condominial."
        }
      },
      cta: "Ver todos os conteúdos"
    },
    finalCta: {
      title: "Quer entender o seu cenário com calma, clareza e estratégia?",
      text: "Se você precisa garantir seus direitos trabalhistas, proteger sua empresa de riscos ou trazer segurança jurídica para o seu condomínio, podemos ajudar.",
      cta1: "Iniciar atendimento no WhatsApp",
      cta2: "Agendar uma consulta"
    },
    contact: {
      title: "Triagem e Atendimento",
      subtitle: "Responda estas rápidas perguntas em 3 passos para que nossa equipe já prepare a melhor solução.",
      form: {
        name: "Seu nome completo *",
        phone: "WhatsApp *",
        email: "Email *",
        situation: "Descreva de forma resumida o motivo do contato...",
        consent: "Li e concordo com a Política de Privacidade e autorizo o contato.",
        submit: "Enviar p/ Análise",
        whatsapp: "Enviar WhatsApp",
        validation: {
          required: "Campo obrigatório.",
          spam: "Atividade suspeita detectada. Tente novamente mais tarde.",
          rateLimit: "Muitos envios recentes. Aguarde um momento e tente novamente.",
          invalidEmail: "E-mail inválido.",
          invalidPhone: "WhatsApp inválido."
        },
        success: "Mensagem enviada com sucesso! Entraremos em contato em breve.",
        error: "Erro ao enviar. Tente novamente."
      },
      info: {
        region: "Atendimento Jundiaí e Região",
        schedule: "Horário:",
        response: "Resposta em até 24 horas úteis."
      }
    },
    footer: {
      credentials: "Luara Rezende — OAB SP 306.297",
      region: "Atendimento em Jundiaí e região · Online para todo o Brasil",
      links: {
        privacy: "Política de Privacidade",
        terms: "Termos de Uso",
        lgpd: "LGPD"
      },
      disclaimer: "As informações deste site são de caráter informativo e não substituem a consulta jurídica individualizada. Não há promessa de resultado; cada caso é único."
    },
    seo: {
      home: {
        title: "Luara Rezende Advocacia | Direito do Trabalho e Condominial em Jundiaí",
        description: "Advocacia estratégica em Jundiaí e região. Atendimento em Direito do Trabalho para trabalhadores e empresas, além de assessoria jurídica para condomínios."
      }
    },
    common: {
      required: "obrigatório",
      optional: "opcional",
      readMore: "Ler mais",
      close: "Fechar",
      send: "Enviar",
      cancel: "Cancelar"
    }
  }
};

const enUS = {
  translation: {
    hero: {
      headline: "Strategic Law in Jundiaí and Region",
      subtext: "Safe solutions in Labor Law for workers and companies, as well as legal advice for condominiums. Humanized, transparent service focused on bringing balance and legal security to your life, business or condominium. In-person service in Jundiaí and online for all Brazil.",
      ctaPrimary: "Talk on WhatsApp",
      ctaSecondary: "Know the practice areas",
      region: "Service in Jundiaí and region · Online for all Brazil",
      trust: "Individual and confidential service. You always talk to a lawyer."
    },
    about: {
      title: "About Luara",
      who: {
        title: "Who I am",
        text: "With over 15 years of experience in Law, I built my career working in large law firms and corporations. Along this journey, I deeply understood the backstage of labor relations and institutional management.\n\nToday, leading my own firm, I use this baggage in a multifaceted way: offering technical and human defense for workers, implementing risk prevention for companies and bringing legal security to condominium management."
      },
      mission: {
        title: "Mission",
        text: "Act with clarity, strategy and commitment in resolving conflicts and the legal security of workers, companies and condominiums."
      },
      vision: {
        title: "Vision", 
        text: "Be a reference in Jundiaí and region for excellence in labor and condominium law, translating legal complexity into practical solutions."
      },
      purpose: {
        title: "Purpose",
        text: "We believe in Law as an instrument of balance, security and pacification of relations."
      }
    },
    practiceAreas: {
      title: "How We Can Help",
      subtitle: "Strategic action in the following fronts:",
      worker: {
        title: "Labor Law for Workers",
        shortDescription: "Guidance and defense of your labor rights in the face of conflicts, terminations, overtime, recognition of employment, harassment, workplace accidents and toxic environments.",
        intro: "We defend your rights with respect, transparency and the security of those who deeply know the backstage of labor relations.",
        cta: "Understand my rights",
        ctaLong: "I want to evaluate my case",
        servicesList: [
          "Analysis of the concrete case and legal guidance",
          "Calculation and conference of severance pay",
          "Analysis of contracts, pay stubs and PJ hiring models",
          "Guidance in cases of harassment, psychological pressure and toxic environment",
          "Extrajudicial agreements and negotiations",
          "Recognition of employment relationship",
          "Overtime and time bank",
          "Additional for unhealthy and dangerous work",
          "Moral damages, harassment and discrimination",
          "Workplace accident and occupational disease",
          "Indirect termination",
          "Salary equalization"
        ]
      },
      corporate: {
        title: "Labor Law for Companies",
        shortDescription: "Preventive labor consulting, contract auditing, reduction of labor liabilities, HR support and defense in lawsuits.",
        intro: "We defend your company's heritage and sustainability through intelligent, preventive and strategic labor legal management.",
        cta: "Protect my company",
        ctaLong: "I want to protect my company",
        servicesList: [
          "Preventive consulting for HR and personnel department",
          "Review of employment contracts",
          "Adequacy of working hours, benefits and internal policies",
          "Audit of labor liabilities",
          "Analysis of PJ hiring and outsourcing",
          "Defense in labor claims",
          "Support in hearings, mediations and inspections",
          "Strategy for risk reduction and legal predictability"
        ]
      },
      condominium: {
        title: "Condominium Law",
        shortDescription: "Legal advice for property managers, administrators and councils, focusing on defaults, assemblies, conventions, internal regulations and condominium conflicts.",
        intro: "Life in a condominium requires clear rules, agile mediation and legal security. We support property managers, councils and administrators in the search for efficient, harmonious and legally secure management.",
        cta: "Value my condominium",
        ctaLong: "I want support for my condominium",
        servicesList: [
          "Amicable and judicial collection of condominium quotas",
          "Review of conventions and internal regulations",
          "Advice in face-to-face and virtual assemblies",
          "Support in drafting notices and minutes",
          "Mediation of conflicts between residents",
          "Guidance on works, use of common areas and internal rules",
          "Condominium labor relations",
          "Analysis of contracts with outsourced companies"
        ]
      }
    },
    methodology: {
      title: "How does it work?",
      subtitle: "My approach is based on three fundamental pillars that guarantee a complete and personalized service.",
      steps: {
        listen: {
          title: "Listen",
          text: "First, I listen to your story carefully. I understand the context, the facts and your concerns to map the situation."
        },
        analyze: {
          title: "Analyze",
          text: "I analyze your case from a legal perspective, identifying rights, deadlines and the best strategies for action."
        },
        strategy: {
          title: "Strategy",
          text: "I develop a personalized action plan, explaining the available options and the most appropriate paths for your case."
        }
      }
    },
    differentiators: {
      title: "Differentiators",
      items: {
        communication: {
          title: "Clear Communication",
          text: "Guidance without legal jargon, with objective explanations so you understand risks, paths and next steps."
        },
        experience: {
          title: "Backstage Experience",
          text: "Experience in large law firms and corporations allows a strategic vision of labor relations, risk prevention and institutional management."
        },
        preventive: {
          title: "Preventive Approach",
          text: "Action aimed at avoiding conflicts, reducing risks and bringing more security before the problem becomes a lawsuit."
        },
        human: {
          title: "Humanized Service",
          text: "Active listening, transparency and careful conduct in themes that impact people, companies and communities."
        }
      }
    },
    testimonials: {
      title: "What they say about the service",
      items: {
        testimonial1: {
          text: "Luara explained everything calmly and solved my case with great transparency.",
          author: "[Name]",
          role: "[Profession]"
        },
        testimonial2: {
          text: "I felt safe to decide. I recommend Luara's human service.",
          author: "[Name]",
          role: "[Company]"
        }
      },
      note: "Testimonials published only with express consent.",
      cases: {
        title: "Success Cases",
        disclaimer: "* Real accounts anonymized to protect identity in accordance with the code of ethics.",
        condominium: {
          title: "Default Recovery",
          text: "Condominium faced 30% chronic default. In 6 months of active legal management, with humanized extrajudicial collections and negotiation shifts, we reduced the deficit to less than 5%, guaranteeing cash flow for urgent maintenance."
        },
        worker: {
          title: "Employment Recognition",
          text: "Worker acted for over 4 years as a service provider (PJ) but with a CLT routine. We obtained judicial recognition of the employment relationship and full payment of FGTS, proportional vacations and 13th salary."
        }
      }
    },
    faq: {
      title: "Frequently asked questions",
      tabs: {
        worker: "Labor Law for Workers",
        corporate: "Labor Law for Companies",
        condominium: "Condominium Law"
      }
    },
    content: {
      title: "Contents & Blog",
      subtitle: "Articles and strategic guidance.",
      categories: {
        worker: {
          title: "Worker's Rights",
          description: "Articles on severance pay, overtime, work environment, employment relationship, harassment and rights at work."
        },
        corporate: {
          title: "Management & Companies",
          description: "Contents on prevention of labor risks, secure contracts, HR routines, legal compliance and corporate protection."
        },
        condominium: {
          title: "Condominium Life",
          description: "Guidance for property managers, councilors and residents on defaults, assemblies, internal rules, conflicts and condominium management."
        }
      },
      cta: "See all contents"
    },
    finalCta: {
      title: "Want to understand your scenario calmly, clearly and strategically?",
      text: "If you need to guarantee your labor rights, protect your company from risks or bring legal security to your condominium, we can help.",
      cta1: "Start service on WhatsApp",
      cta2: "Schedule a consultation"
    },
    contact: {
      title: "Screening and Service",
      subtitle: "Answer these quick questions in 3 steps so our team can prepare the best solution.",
      form: {
        name: "Full name *",
        phone: "WhatsApp *",
        email: "E-mail *",
        situation: "Briefly describe the reason for contact...",
        consent: "I have read and agree to the Privacy Policy and authorize the contact.",
        submit: "Send for Analysis",
        whatsapp: "Send WhatsApp",
        validation: {
          required: "Required field.",
          spam: "Suspicious activity detected. Please try again later.",
          rateLimit: "Too many recent submissions. Please wait a moment and try again.",
          invalidEmail: "Invalid email.",
          invalidPhone: "Invalid WhatsApp."
        },
        success: "Message sent successfully! We will contact you soon.",
        error: "Error sending. Try again."
      },
      info: {
        region: "Service in Jundiaí and Region",
        schedule: "Hours:",
        response: "Response within 24 business hours."
      }
    },
    footer: {
      credentials: "Luara Rezende — OAB SP 306.297",
      region: "Service in Jundiaí and region · Online for all Brazil",
      links: {
        privacy: "Privacy Policy",
        terms: "Terms of Use",
        lgpd: "LGPD"
      },
      disclaimer: "The information on this site is for informational purposes and does not replace individualized legal consultation. There is no promise of result; each case is unique."
    },
    seo: {
      home: {
        title: "Luara Rezende Advocacia | Labor and Condominium Law in Jundiaí",
        description: "Strategic law in Jundiaí and region. Service in Labor Law for workers and companies, as well as legal advice for condominiums."
      }
    },
    common: {
      required: "required",
      optional: "optional",
      readMore: "Read more",
      close: "Close",
      send: "Send",
      cancel: "Cancel"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': ptBR,
      'en-US': enUS
    },
    fallbackLng: 'pt-BR',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
